<div
  class="fixed bottom-4 left-0 w-full"
  [ngClass]="{
    'top-4': position === 'top',
    'bottom-2': position === 'bottom',
  }"
>
  <div class="flex justify-between items-center w-[55%] m-auto">
    <button
      class="bg-[#FDDE2F] flex items-center justify-center rounded-[40px] ml-3 w-[40px] h-[40px]"
      (click)="onNextLead.emit('back')"
    >
      <ui-icon name="arrow-left" fill="neutrals-900" m-size="24" size="24" />
    </button>
    <div
      class="w-full max-w-[600px] p-6 bg-white border border-gray-300 rounded-lg shadow-lg"
      style="z-index: 1000"
      *ngIf="isVisible"
    >
      <div class="flex justify-between items-center gap-6">
        <ui-icon name="archive" fill="neutrals-900" m-size="24" size="24" />
        <div class="flex-1">
          <p class="text-alert text-[#11181C]">Se ha archivado el chat</p>
        </div>
        <button
          class="text-alert-btn text-[#070B10] hover:text-gray-800 py-2 px-6 text-center min-w-[140px] flex justify-center items-center"
          (click)="unArchiveChatLead()"
        >
          <p *ngIf="!isLoading">Desarchivar</p>
          <ui-loader *ngIf="isLoading" type="primary" size="2xl" />
        </button>
        <button
          class="flex items-center justify-center p-2"
          (click)="closeModal()"
        >
          <ui-icon name="close" fill="neutrals-900" m-size="24" size="24" />
        </button>
      </div>
    </div>
    <button
      class="bg-[#FDDE2F] flex items-center justify-center rounded-[40px] mr-3 w-[40px] h-[40px]"
      (click)="onNextLead.emit('next')"
    >
      <ui-icon name="arrow-right" fill="neutrals-900" m-size="24" size="24" />
    </button>
  </div>
</div>
